<template>
    <main v-if="data && data.page">
        <div class="conferenceHeader">
            <div class="infoBar">
                <WebsiteBreadcrumbs>
                    <NuxtLink to="/conferences">conferences</NuxtLink>
                    <a v-if="data.page.season">{{ data.page.season.toLowerCase() }}</a>
                </WebsiteBreadcrumbs>
            </div>
            <h1 class="helvetica title1">{{ data.page?.title }}</h1>
            <LazyNeverItemConferenceSubtitle :page="data.page" hydrate-never />
            <!--<div class="topic helvetica title5" v-if="data.page.topic">{{ data.page.topic }}</div>-->
            <div class="place helvetica title5">{{ data.page.location }}</div>
        </div>
        <div class="conferenceNav noselect">
            <NTabs type="line" animated v-model:value="tabValue" @update:value="tabChanged">
                <NTab name="overview" tab="overview" />
                <NTab name="gallery" tab="gallery" v-if="data?.page.show_gallery_page" />
                <NTab name="registration" tab="registration" v-if="data?.page.show_registration_page" />
                <NTab name="programme" tab="programme" v-if="data?.page.show_programme_page" />
                <NTab name="workshop" tab="workshop" v-if="data?.page.show_workshop_page" />
                <NTab name="speakers" tab="speakers" v-if="data?.page.show_speakers_page" />
                <NTab name="accommodation" tab="accommodation" v-if="data?.page.show_accomodation_page" />
                <NTab name="links" tab="links" v-if="data?.page.show_links_page" />
            </NTabs>
        </div>
        <NuxtPage />
    </main>
</template>

<script lang="ts" setup>
import type { RouteRecordName } from '#vue-router';
import { NTabs, NTab } from 'naive-ui';

const { getConference } = useConferences();
const directusUrl = useDirectusUrl()
const route = useRoute()

const { data } = useAsyncData(`conferences-${route.params.slug}`, () => getConference(route.params.slug));

const tabValue = ref<string>('overview')

const updateTabValue = (name: RouteRecordName) => {
    switch (name) {
        case 'conferences-slug':
            tabValue.value = 'overview'
            break;
        case 'conferences-slug-gallery':
            tabValue.value = 'gallery'
            break;
        case 'conferences-slug-registration':
            tabValue.value = 'registration'
            break;
        case 'conferences-slug-programme':
            tabValue.value = 'programme'
            break;
        case 'conferences-slug-speakers':
            tabValue.value = 'speakers'
            break;
        case 'conferences-slug-workshop':
            tabValue.value = 'workshop'
            break;
        case 'conferences-slug-accommodation':
            tabValue.value = 'accommodation'
            break;
    }
}

watch(() => route.name, () => {
    if (route.name) updateTabValue(route.name)
})
if (route.name) updateTabValue(route.name)

const tabChanged = async (page: string) => {
    if (page == 'overview') await navigateTo({ name: `conferences-slug`, params: { slug: route.params.slug } })
    else await navigateTo({ name: `conferences-slug-${page}`, params: { slug: route.params.slug } })
}

useSeoMeta({
    description: () => data.value?.page?.summary,
    ogDescription: () => data.value?.page?.summary,
    twitterDescription: () => data.value?.page?.summary,

    ogImage: () => data.value?.page?.cover?.id ? directusUrl + '/assets/' + data.value?.page.cover.id : undefined,
})
</script>

<style lang="scss" scoped>
main {
    padding-top: var(--size-padding-header);

    .conferenceHeader {
        padding: 0 var(--size-margin-page) var(--size-gutter-sections) var(--size-margin-page);

        .infoBar {
            display: grid;
            grid-template-columns: repeat(2, minmax(0, 1fr));
            gap: var(--size-margin-page);

            margin-bottom: var(--size-gutter-default);
            color: var(--color-primary);
        }

        h2 {
            margin-bottom: var(--size-gutter-default);
        }

        .topic {
            color: var(--color-primary);
        }
    }

    .conferenceNav {
        margin: 0 var(--size-margin-page);
        padding-bottom: var(--size-gutter-double);
    }
}

@media screen and (max-width: 600px) {
    main {
        .infoBar {
            grid-template-columns: 1fr;
        }

        .conferenceNav {
            margin-right: 0;
            margin-left: 0;
        }
    }
}
</style>